// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block-wrapper--xs-1 {
  margin-left: var(--offset-external-xs);
  margin-right: var(--offset-external-xs);
}
.block-wrapper--xs-1-2l {
  margin-left: var(--offset-external-xs);
  margin-right: var(--offset-internal-xs);
}
.block-wrapper--xs-1-2r {
  margin-left: var(--offset-internal-xs);
  margin-right: var(--offset-external-xs);
}
.block-wrapper--xs-1-3l {
  margin-left: var(--offset-external-xs);
  margin-right: var(--offset-internal-xs);
}
.block-wrapper--xs-1-3r {
  margin-left: var(--offset-internal-xs);
  margin-right: var(--offset-external-xs);
}
.block-wrapper--xs-2-3l {
  margin-left: var(--offset-external-xs);
  margin-right: var(--offset-internal-xs);
}
.block-wrapper--xs-2-3r {
  margin-left: var(--offset-internal-xs);
  margin-right: var(--offset-external-xs);
}
@media (min-width: 768px) {
  .block-wrapper--md-1 {
    margin-left: var(--offset-external-md);
    margin-right: var(--offset-external-md);
  }
}
@media (min-width: 768px) {
  .block-wrapper--md-1-2l {
    margin-left: var(--offset-external-md);
    margin-right: var(--offset-internal-md);
  }
}
@media (min-width: 768px) {
  .block-wrapper--md-1-2r {
    margin-left: var(--offset-internal-md);
    margin-right: var(--offset-external-md);
  }
}
@media (min-width: 768px) {
  .block-wrapper--md-1-3l {
    margin-left: var(--offset-external-md);
    margin-right: var(--offset-internal-md);
  }
}
@media (min-width: 768px) {
  .block-wrapper--md-1-3r {
    margin-left: var(--offset-internal-md);
    margin-right: var(--offset-external-md);
  }
}
@media (min-width: 768px) {
  .block-wrapper--md-2-3l {
    margin-left: var(--offset-external-md);
    margin-right: var(--offset-internal-md);
  }
}
@media (min-width: 768px) {
  .block-wrapper--md-2-3r {
    margin-left: var(--offset-internal-md);
    margin-right: var(--offset-external-md);
  }
}
@media (min-width: 1200px) {
  .block-wrapper--xl-1 {
    margin-left: var(--offset-external-xl);
    margin-right: var(--offset-external-xl);
  }
}
@media (min-width: 1200px) {
  .block-wrapper--xl-1-2l {
    margin-left: var(--offset-external-xl);
    margin-right: var(--offset-internal-xl);
  }
}
@media (min-width: 1200px) {
  .block-wrapper--xl-1-2r {
    margin-left: var(--offset-internal-xl);
    margin-right: var(--offset-external-xl);
  }
}
@media (min-width: 1200px) {
  .block-wrapper--xl-1-3l {
    margin-left: var(--offset-external-xl);
    margin-right: var(--offset-internal-xl);
  }
}
@media (min-width: 1200px) {
  .block-wrapper--xl-1-3r {
    margin-left: var(--offset-internal-xl);
    margin-right: var(--offset-external-xl);
  }
}
@media (min-width: 1200px) {
  .block-wrapper--xl-2-3l {
    margin-left: var(--offset-external-xl);
    margin-right: var(--offset-internal-xl);
  }
}
@media (min-width: 1200px) {
  .block-wrapper--xl-2-3r {
    margin-left: var(--offset-internal-xl);
    margin-right: var(--offset-external-xl);
  }
}
.block-wrapper-container--vertical-spacing-none {
  margin-top: 0px;
  margin-bottom: 0px;
}
.block-wrapper-container--vertical-spacing-small {
  margin-top: 20px;
  margin-bottom: 20px;
}
.block-wrapper-container--vertical-spacing-medium {
  margin-top: 65px;
  margin-bottom: 65px;
}
.block-wrapper-container--vertical-spacing-large {
  margin-top: 70px;
  margin-bottom: 70px;
}`, "",{"version":3,"sources":["webpack://./src/components/wrappers/BlockWrapper/BlockWrapper.scss"],"names":[],"mappings":"AAyBQ;EACI,sCAfI;EAgBJ,uCAhBI;AARhB;AAsBQ;EACI,sCAfI;EAgBJ,uCAhBI;AAJhB;AAkBQ;EACI,sCAfI;EAgBJ,uCAhBI;AAAhB;AAcQ;EACI,sCAfI;EAgBJ,uCAhBI;AAIhB;AAUQ;EACI,sCAfI;EAgBJ,uCAhBI;AAQhB;AAMQ;EACI,sCAfI;EAgBJ,uCAhBI;AAYhB;AAEQ;EACI,sCAfI;EAgBJ,uCAhBI;AAgBhB;AAMY;EADJ;IAEQ,sCAnBA;IAoBA,uCApBA;EAiBd;AACF;AAAY;EADJ;IAEQ,sCAnBA;IAoBA,uCApBA;EAuBd;AACF;AANY;EADJ;IAEQ,sCAnBA;IAoBA,uCApBA;EA6Bd;AACF;AAZY;EADJ;IAEQ,sCAnBA;IAoBA,uCApBA;EAmCd;AACF;AAlBY;EADJ;IAEQ,sCAnBA;IAoBA,uCApBA;EAyCd;AACF;AAxBY;EADJ;IAEQ,sCAnBA;IAoBA,uCApBA;EA+Cd;AACF;AA9BY;EADJ;IAEQ,sCAnBA;IAoBA,uCApBA;EAqDd;AACF;AA3BY;EADJ;IAEQ,sCAxBA;IAyBA,uCAzBA;EAuDd;AACF;AAjCY;EADJ;IAEQ,sCAxBA;IAyBA,uCAzBA;EA6Dd;AACF;AAvCY;EADJ;IAEQ,sCAxBA;IAyBA,uCAzBA;EAmEd;AACF;AA7CY;EADJ;IAEQ,sCAxBA;IAyBA,uCAzBA;EAyEd;AACF;AAnDY;EADJ;IAEQ,sCAxBA;IAyBA,uCAzBA;EA+Ed;AACF;AAzDY;EADJ;IAEQ,sCAxBA;IAyBA,uCAzBA;EAqFd;AACF;AA/DY;EADJ;IAEQ,sCAxBA;IAyBA,uCAzBA;EA2Fd;AACF;AA7DQ;EACI,eAAA;EACA,kBAAA;AA+DZ;AA5DQ;EACI,gBAAA;EACA,mBAAA;AA8DZ;AA3DQ;EACI,gBAAA;EACA,mBAAA;AA6DZ;AA1DQ;EACI,gBAAA;EACA,mBAAA;AA4DZ","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
